import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from "../i18n/useTranslation";


export default function CartBar({ onOpen }) {
  const { basketTotalQuantity, basketTotalPrice } = useAuth();
  const { t } = useTranslation();

  if (!basketTotalQuantity) return null;

  return (
    <div className="modal-close-container modal-back-trans " onClick={onOpen}>
     <div className="modal-close-bar">
<span className="btn-left">{basketTotalQuantity}</span>
<span className="btn-center">{t("view_order")}</span>
<span className="btn-right">{(basketTotalPrice|| 0).toFixed(2)} €</span>
</div>
    </div>



    
  );
}